/**
 * 指定数値までのランダムな数値を返します
 *
 * @param max 返却最大数値（デフォルト: 100）
 */
export function getRandomNumber(max: number = 100): number {
  if (max == null || max < 0) {
    console.error('Invalid max value. max:', max)
    return 0
  }

  return Math.floor(Math.random() * max)
}

/**
 * 正の整数かどうか
 *
 * @param value 対象の数値
 */
export function isPositiveInteger(value: number): boolean {
  return value > 0 && Number.isInteger(value)
}

/**
 * 0 以上の整数かどうか
 *
 * @param value 対象の数値
 */
export function isNonNegativeInteger(value: number): boolean {
  return value >= 0 && Number.isInteger(value)
}
